/* eslint-disable react/destructuring-assignment */
import React from 'react';
import LayoutHeader from './header';
import LayoutFooter from './footer';

import { RouteAndChildrenProps } from '../@jms-react/types/aux-props';

export function LayoutHeaderFooter(props: RouteAndChildrenProps) {
  return (
    <>
      <LayoutHeader {...props} />
      <div className="scroll">{props.children}</div>
      <LayoutFooter />
    </>
  );
}
